// extracted by mini-css-extract-plugin
export default {"link":"TableLink_link__r7kog"};